"use strict";

module.exports = function() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$parsers.unshift(function (viewValue) {
        ctrl.$setValidity("passwordVerify", true);

        // check length
        if (viewValue.length < 8) {
          ctrl.$setValidity("passwordVerify", false);
        }

        // check that password contains letters and numbers
        if (!viewValue.match(".*\\d.*") || !viewValue.match(".*[a-zA-Z].*")){
          ctrl.$setValidity("passwordVerify", false);
        }

        return viewValue;
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/passwordValidator.js